import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoComponent } from "../../components/global/info/info.component";
import { LoadingComponent } from '@app/components/global/loading/loading.component';
import { CancelAppointment } from '@app/services/fetch/cancel';
import { AppointmentService } from '@app/services/appointment/appointment.service';
import { Completion } from '@app/services/fetch/completion';

@Component({
  selector: 'afcu-informations',
  standalone: true,
  imports: [InfoComponent, LoadingComponent],
  templateUrl: './informations.component.html'
})
export class InformationsComponent {

  protected cancel = inject( CancelAppointment );
  protected appointmentService = inject(AppointmentService)
  protected completionService = inject(Completion)
  protected target = ''
  // isLoading = false

  constructor (protected route: ActivatedRoute) {
    this.target = this.route.snapshot.paramMap.get('reason')!

    if (this.target == null)
      this.route.data.subscribe(data => {
        this.target = data['target']

        if(this.target == 'cancel'){
          if (this.appointmentService.appointmentID() !== -1) {
            this.cancel.eventID.set(this.appointmentService.appointmentID())
          } else if (this.completionService.completionResponse()?.eventID !== undefined){
            this.cancel.eventID.set(this.completionService.completionResponse()?.eventID!)
          }
        }
        
      });
  }

  get isLoading() {
    return (this.target === 'cancel') ? this.cancel.cancelResource.isLoading() : false
  }
}
